import api from '../../../api/client'

function toQuery(params = {}) {
  const searchParams = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value === '' || value === null || value === undefined) return
    searchParams.set(key, String(value))
  })
  const query = searchParams.toString()
  return query ? `?${query}` : ''
}

export async function listNotifications(params = {}) {
  const { data } = await api.get(`/notifications/${toQuery(params)}`)
  return data
}

export async function getNotificationSummary(params = {}) {
  const { data } = await api.get(`/notifications/summary${toQuery(params)}`)
  return data
}

export async function markNotificationRead(notificationId) {
  const { data } = await api.patch(`/notifications/${notificationId}/read`)
  return data
}

export async function markAllNotificationsRead(params = {}) {
  const { data } = await api.patch(`/notifications/read-all${toQuery(params)}`)
  return data
}

export async function archiveNotification(notificationId) {
  const { data } = await api.patch(`/notifications/${notificationId}/archive`)
  return data
}

export async function unarchiveNotification(notificationId) {
  const { data } = await api.patch(`/notifications/${notificationId}/unarchive`)
  return data
}

export async function archiveNotificationsBulk(payload) {
  const { data } = await api.patch('/notifications/archive', payload)
  return data
}
